"use strict" ;

function SessionStorage(window) {
	var engine = window.sessionStorage ;

	var setItem = function(key, value) {
		engine.setItem(key, JSON.stringify(value)) ;
	}

	var getItem = function(key) {
		var value = engine.getItem(key) || "{}";
		return JSON.parse(value) ;
	}

	var removeItem = function(key) {
		engine.removeItem(key);
	}

	var clear = function() {
		engine.clear();
	}

	return {
		setItem: setItem,
		getItem: getItem,
		removeItem: removeItem,
		clear: clear
	};
}
